import React from 'react';

import NavBar from '@sp/client/components/NavBar';

import s from './style.less';

const Provider = () => (
  <NavBar>
    <div className={s.root}>
      <div>
        <div className={s.header}>Service Plans</div>
      </div>
      <div className={s.subheader}>
        Welcome to your service plan homepage. Manage all of your plans here.
      </div>
    </div>
  </NavBar>
);

export default Provider;
